import React from 'react';
import SafeIcon from '../common/SafeIcon';

const ComparisonSection = () => {
  return (
    <section className="py-24 bg-zinc-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tight mb-4">The PulseForge Advantage</h2>
          <p className="text-zinc-400">Why athletes choose our engineered solutions over basic alternatives.</p>
        </div>

        <div className="overflow-x-auto hide-scrollbar">
          <table className="w-full text-left border-collapse min-w-[600px]">
            <thead>
              <tr>
                <th className="p-4 border-b-2 border-zinc-800 w-1/3"></th>
                <th className="p-4 border-b-2 border-red-600 bg-zinc-900/50 text-center w-1/3">
                  <span className="font-black text-xl text-white uppercase">PulseForge</span>
                </th>
                <th className="p-4 border-b-2 border-zinc-800 text-center w-1/3 text-zinc-500 uppercase text-sm font-bold">
                  Basic Foam Rollers
                </th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {[
                { feature: 'Targeted Deep Tissue Penetration', pf: true, basic: false },
                { feature: 'Dynamic Compression Technology', pf: true, basic: false },
                { feature: 'Adjustable Intensity Levels', pf: true, basic: false },
                { feature: 'Portability for Travel', pf: true, basic: true },
                { feature: 'Active Heat/Cold Integration', pf: true, basic: false }
              ].map((row, idx) => (
                <tr key={idx} className="border-b border-zinc-800/50 hover:bg-zinc-900/30 transition-colors">
                  <td className="p-4 text-zinc-300 font-medium">{row.feature}</td>
                  <td className="p-4 bg-zinc-900/20 text-center">
                    {row.pf ? <SafeIcon name="CheckCircle" className="text-red-500 mx-auto text-xl" /> : <SafeIcon name="X" className="text-zinc-600 mx-auto" />}
                  </td>
                  <td className="p-4 text-center">
                    {row.basic ? <SafeIcon name="CheckCircle" className="text-zinc-500 mx-auto text-xl" /> : <SafeIcon name="X" className="text-zinc-600 mx-auto" />}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;